import React from "react";
import { Image } from "react-bootstrap";
import { Link } from "react-router-dom";

const FeedbackSuccess = () => {

  return (
    <div className="no-bot-exists-card mt-5">
      <div className="no-bot-exists-img-sec">
        <Image
          className="no-bot-exists-img"
          src={window.location.origin + "/images/illustrations/feedback.png"}
        />
      </div>
      <div className="no-bot-exists-info">
        <h4>Thank you for submitting your contact details. <br /> We appreciate your inquiry. Rest assured, our team will be in touch with you very soon.</h4>
      </div>
      <Link to="/" className="settings-btn">
        Back To Home
      </Link>
    </div>
  );
};

export default FeedbackSuccess;